import ModifyProjectGroupsForAdmin, {
  ModifyProjectGroupsForAdminProps,
} from '@/connection/projects/modify-project-groups-for-admin';
import { serializeError } from '@/store/utils/serialize-error';
import { ProjectsReducerCreator } from '../types';

const modifyProjectGroupsForAdminReducer = (create: ProjectsReducerCreator) => {
  return create.asyncThunk(
    async (params: ModifyProjectGroupsForAdminProps, { rejectWithValue }) => {
      try {
        const res = await ModifyProjectGroupsForAdmin(params);
        return res;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        if (state.projectGroups) {
          const { added, deleted, adminId } = action.payload;
          state.projectGroups = state.projectGroups.map((pg) => {
            if (added.includes(pg.uuid)) {
              return {
                ...pg,
                adminIds: [...pg.adminIds, adminId],
              };
            }
            if (deleted.includes(pg.uuid)) {
              return {
                ...pg,
                adminIds: pg.adminIds.filter((admin) => admin !== adminId),
              };
            }
            return pg;
          });
        }
      },
      rejected: (state) => {
        state.groupError = 'Error modifying event folders for admin';
      },
    }
  );
};

export default modifyProjectGroupsForAdminReducer;
